module.exports = __webpack_public_path__ + "3f3bc4699455893d3197cda4be1e4b3c.svg";